module.exports = __webpack_public_path__ + "assets/img/blank.10a0acfc.svg";